import FormPayStub from './FormPayStub'

export default FormPayStub
